angular.module('feedBackServiceModule', [
	'myFeedBackModule',
	'submitFeedBackModule'
])
    .factory('feedBackService', ['$q', '$modal', function($q, $modal) {
        return {
            /**
             * [submitFeedBack description] 提交意见反馈表单
             * @return {[type]} [description]
             */
            submitFeedBack() {
                let deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./feedBack/services/submitFeedBack/submitFeedBack_tpl.html",
                    windowClass: "submit_feed_back",
                    backdrop: false,
                    controller: "submitFeedBackCtrl",
                    resolve: {

                    }
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve();
                }, function() {
                    deffer.reject();
                });
                return deffer.promise;
            },
            /**
             * [myFeedBack description] 我的反馈弹窗
             * @return {[type]} [description]
             */
            myFeedBack() {
                let deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./feedBack/services/myFeedBack/myFeedBack_tpl.html",
                    windowClass: "my_feed_back",
                    backdrop: false,
                    controller: "myFeedBackCtrl",
                    resolve: {

                    }
                });
                modalInstance.result.then(function(result) {
                    deffer.resolve();
                }, function() {
                    deffer.reject();
                });
                return deffer.promise;
            }
        };
    }]);